import { ValueTableConfiguration } from "../../../../../rule-engine-core/Rule/Table/Value/ValueTableConfiguration";
import type {
    DemoRuleIntegrationAdapter,
    RuleConfigFactoryContext,
    RuleDemoDataProjectionPort,
    RuleEvaluatorPort,
    RulePolicyBinding,
    RuleRowMapperPort,
    RuleSummaryPresenterPort,
} from "../../ruleIntegrationTypes";
import { identityRuleRowMapper } from "../../ruleIntegrationTypes";
import { withExecutableRuntimeEvidence } from "../runtimeEvidence";
import { valueTableStorageCodec } from "../storageCodecs";

export const VALUE_TABLE_EXECUTABLE_TYPE = "ValueTableConfiguration";

export type CreateValueTableIntegrationAdapterParams<DemoRow, RuntimeRow = DemoRow> = {
    ruleId: string;
    policyBinding?: RulePolicyBinding;
    createConfig: (context?: RuleConfigFactoryContext) => ValueTableConfiguration;
    rowMapper?: RuleRowMapperPort<DemoRow, RuntimeRow>;
    evaluator: RuleEvaluatorPort<ValueTableConfiguration, RuntimeRow>;
    summaryPresenter: RuleSummaryPresenterPort<ValueTableConfiguration>;
    demoDataProjection?: RuleDemoDataProjectionPort<ValueTableConfiguration>;
};

export const createValueTableIntegrationAdapter = <DemoRow, RuntimeRow = DemoRow>({
    ruleId,
    policyBinding,
    createConfig,
    rowMapper,
    evaluator,
    summaryPresenter,
    demoDataProjection,
}: CreateValueTableIntegrationAdapterParams<DemoRow, RuntimeRow>): DemoRuleIntegrationAdapter<
    ValueTableConfiguration,
    DemoRow,
    RuntimeRow
> => ({
    ruleId,
    status: "adapter_backed",
    appGlueExecutableType: VALUE_TABLE_EXECUTABLE_TYPE,
    editorSurface: "native_value_table_builder",
    policyBinding,
    ports: {
        configFactory: { createConfig },
        storageCodec: valueTableStorageCodec(),
        rowMapper: rowMapper ?? (identityRuleRowMapper<DemoRow>() as unknown as RuleRowMapperPort<DemoRow, RuntimeRow>),
        evaluator: withExecutableRuntimeEvidence(VALUE_TABLE_EXECUTABLE_TYPE, evaluator),
        summaryPresenter,
        demoDataProjection,
    },
});
